import { render, staticRenderFns } from "./ProdutosBuscar.vue?vue&type=template&id=f77de65a&scoped=true&"
import script from "./ProdutosBuscar.vue?vue&type=script&lang=js&"
export * from "./ProdutosBuscar.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosBuscar.vue?vue&type=style&index=0&id=f77de65a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77de65a",
  null
  
)

export default component.exports